export const sizes = {
    medium: 'medium',
    small: 'small',
};
export const types = {
    primary: 'primary',
    secondary: 'secondary',
};
